<template lang="html">
  <el-dialog
    title="添加货物"
    v-if="dialogVisible"
    :visible="dialogVisible"
    :append-to-body="true"
    @close="close"
    width="800px"
  >
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100"
      label-position="left"
      class="add-goods-form"
    >
      <el-form-item label="货物：" prop="goodsCategoryid" class="goods-item">
        <el-select
          filterable
          v-model="ruleForm.goodsCategoryid"
          placeholder="请选择货物"
          @focus="selectFocus"
          @change="selectChange"
        >
          <el-option
            v-for="item in goodsArr"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="重量：" prop="goodsWeight" class="goods-weight-item">
        <el-input
          type="number"
          v-model="ruleForm.goodsWeight"
          placeholder="请选择重量"
        ></el-input>
      </el-form-item>
      <el-form-item label="件数：" prop="goodsNumber">
        <el-input
          type="number"
          v-model="ruleForm.goodsNumber"
          placeholder="请选择件数"
        ></el-input>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="submit">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    selectedGoodsIds: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      ruleForm: {},
      rules: {},
      goodsArr: JSON.parse(sessionStorage.getItem("goodsArr"))
    };
  },
  computed: {},
  methods: {
    selectFocus(bigIndex, i) {
      let savedGoodsArr = JSON.parse(sessionStorage.getItem("goodsArr"));
      this.goodsArr = savedGoodsArr.filter(
        item => !this.selectedGoodsIds.includes(item.value)
      );
    },
    selectChange(val) {
      this.ruleForm.goodsName = this.goodsArr.find(
        item => item.value === val
      ).label;
    },
    close() {
      this.$emit("update:dialogVisible", false);
    },
    submit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.$message.success({
            message: "货物添加成功",
            duration: 2000
          });
          this.close();
          this.$emit("addGoodsSuccess", this.ruleForm);
        } else {
          return false;
        }
      });
    },
    setRules() {
      this.rules = {
        goodsCategoryid: [
          {
            required: true,
            message: "请选择货物",
            trigger: ["blur", "change"]
          }
        ],
        goodsWeight: [
          {
            required: true,
            message: "请输入重量",
            trigger: ["blur", "change"]
          }
        ]
      };
    },
    initData() {
      this.ruleForm = {
        goodsCategoryid: "",
        goodsName: "",
        goodsWeight: "",
        goodsNumber: ""
      };
      this.setRules();
    }
  },
  watch: {
    dialogVisible(newVal) {
      newVal && this.initData();
    }
  },
  components: {}
};
</script>

<style lang="scss">
.add-goods-form {
  display: flex;
  .el-form-item {
    flex: 1;
    display: flex;
    .el-form-item__label {
      width: 76px;
    }
  }
  .goods-item {
    .el-input__inner {
      height: 40px !important;
    }
  }
  .goods-weight-item {
    padding: 0 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/personal/deliver/components/handlingWrapper/components/addGoodsDialog/index.vue